// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const beachRoom: Room = {
  name: 'Beach',
  background: '/media/club-penguin/beach.png',
  spawn: { x: 341, y: 338 },
  music: '/media/club-penguin/audio/theme.mp3',

  colliders: [
    ...STANDARD_BOUNDARIES,

    { x: 100, y: 21, w: 402, h: 141 },
    { x: 15, y: 30, w: 93, h: 487 },
    { x: 106, y: 465, w: 833, h: 63 },
    { x: 674, y: 412, w: 266, h: 51 },
    { x: 729, y: 324, w: 210, h: 83 },
    { x: 757, y: 228, w: 176, h: 96 },
    { x: 809, y: 28, w: 130, h: 195 },
    { x: 660, y: 28, w: 147, h: 121 },
    { x: 499, y: 22, w: 173, h: 83 },
  ],

  hotspots: [
    {
      id: 'beach-to-ski-village',
      action: 'goto',
      target: 'ski-village',
      spawn: { x: 245, y: 472 },
      x: 508,
      y: 106,
      w: 89,
      h: 47,
    },
    {
      id: 'beach-to-dock',
      action: 'goto',
      target: 'dock',
      spawn: { x: 172, y: 355 },
      x: 748,
      y: 152,
      w: 60,
      h: 72,
    },
    {
      id: 'intro',

      x: 395,
      y: 177,
      w: 30,
      h: 281,

      action: 'dialogue',
      target: '',
      spawn: { x: 395, y: 177 },
      dialogueOptions: [
        {
          condition: { type: 'first_interaction' },
          text: [
            { text: 'hey, click me.' },
            { text: 'OWWWW' },
            { text: "jk lol i'm literally not real." },
            { text: 'click me harder daddy.' },
            { text: 'you freak' },
            { text: 'oh yes, i remember this game. it was a game about a penguin.' },
            { text: 'a penguin game.' },
            { text: 'good times... good times.' },
          ],
          onComplete: {
            setFlag: { key: 'intro_complete', value: true },
          },
        },
        {
          condition: { type: 'flag_equals', key: 'intro_complete', value: true },
          text: 'the intro is done now.',
        },
      ],
    },
    {
      id: 'lighthouse',
      x: 216,
      y: 112,
      w: 73,
      h: 101,

      action: 'dialogue',
      target: '',
      spawn: { x: 251, y: 102 },
      dialogueOptions: [
        {
          condition: { type: 'first_interaction' },
          position: { x: 251, y: 102 },
          text: [
            { text: "the lighthouse is a nice place to go. but you can't go there." },
            { text: "it's a trap." },
            { text: "you'll be eaten by a grue." },
            { text: "okay... here's the truth. i'm a dick." },
            { text: 'the developer is a dick.' },
            { text: "i'm sorry. i'm just lazy." },
          ],
        },
        {
          condition: { type: 'always' },
          text: 'dude fuck OFF.',
        },
      ],
    },
  ],
};
